import { Address } from './address'

export enum Salutation {
  HERR = 'HERR',
  FRAU = 'FRAU',
}

export interface User {
  salutation: Salutation
  firstName: string
  lastName: string
  phoneNumber: string
  email: string
  dataProtectionAccepted: boolean
  hasNotSeenContactForm: boolean
}

export interface UserInfoBody {
  salutation: string
  firstname: string
  lastname: string
  email: string
  phoneNumberCountryCode: string
  phoneNumberAreaCode: string
  phoneNumberSubscriber: string
  phoneNumber: string
  address: Address
  countryCode: string
  ssoid: string
  clientid: string
}
